import { Home, Sparkles, Truck, CalendarDays } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: Home,
      title: "Standard Cleaning",
      description: "Regular maintenance cleaning for a fresh and tidy home.",
      features: ["Living Areas Cleaning", "Kitchen Cleaning", "Bathroom Cleaning"],
      image: "https://images.unsplash.com/photo-1597665863042-47e00964d899?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1vZGVybiUyMGxpdmluZyUyMHJvb20lMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3NzI3MjcxOTV8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      icon: Sparkles,
      title: "Deep Cleaning",
      description: "Thorough cleaning for a comprehensive refresh of your space.",
      features: ["Detailed Surface Cleaning", "Hard-to-Reach Areas", "Appliance Cleaning"],
      image: "https://images.unsplash.com/photo-1581578949510-fa7315c4c350?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBob3VzZSUyMGNsZWFuaW5nJTIwc2VydmljZXxlbnwwfHx8fDE3NzI3MjcxOTZ8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      icon: Truck,
      title: "Move-In / Move-Out Cleaning",
      description: "Specialized cleaning for transitions between homes.",
      features: ["Pre-Move Cleaning", "Post-Move Cleaning", "Cabinet & Closet Cleaning"],
      image: "https://images.unsplash.com/photo-1593136573819-c3b57b8caf29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGtpdGNoZW4lMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3NzI3MjcxOTZ8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      icon: CalendarDays,
      title: "Recurring Cleaning",
      description: "Scheduled cleaning services to maintain your home's cleanliness.",
      features: ["Weekly Cleaning", "Biweekly Cleaning", "Monthly Cleaning"],
      image: "https://images.unsplash.com/photo-1634672050277-16639332c727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMGtpdGNoZW4lMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3NzI3MjcxOTZ8MA&ixlib=rb-4.1.0&q=85",
    },
  ];

  return (
    <section
      id="services"
      className="section-padding bg-section-alt"
      data-testid="services-section"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Professional Cleaning Services
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Choose from our range of cleaning services designed to meet your specific needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8" data-testid="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card group overflow-hidden"
              data-testid={`service-card-${index}`}
            >
              <div className="flex flex-col lg:flex-row gap-6">
                {/* Image */}
                <div className="lg:w-2/5 flex-shrink-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-48 lg:h-full object-cover rounded-xl"
                  />
                </div>
                {/* Content */}
                <div className="lg:w-3/5">
                  <div className="service-card-icon group-hover:bg-sky-100 transition-colors">
                    <service.icon className="w-7 h-7" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, fIndex) => (
                      <li
                        key={fIndex}
                        className="flex items-center gap-2 text-slate-700"
                      >
                        <div className="w-1.5 h-1.5 rounded-full bg-sky-500" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Transparency Note */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-sky-50 border border-sky-100 rounded-xl px-6 py-4">
            <p className="text-slate-600" data-testid="pricing-note">
              <span className="font-medium text-slate-800">Note:</span> Service pricing 
              varies depending on home size, service type, and cleaning frequency. 
              Contact us for a personalized quote.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
